import i from "classnames";
import e from "react";
import { useSizeAttrs as g } from "../utils/hooks/useSizeAttrs.esm.js";
import { ScreenReaderOnly as u } from "../utils/sr-only.esm.js";
import { RatingNumber as _ } from "./rating-number.esm.js";
import { RatingReview as p } from "./rating-review.esm.js";
import { s } from "../rating.module-BNUHsKEH.mjs";
const d = ({
  dataTestId: a = "fuse-rating",
  size: r = "large",
  rating: t = 0,
  showRating: l = !1,
  reviewLinkText: m,
  reviewLink: o,
  ...n
}) => {
  const c = `${t} out of 5 stars`, f = g(r, {});
  return /* @__PURE__ */ e.createElement(
    "div",
    {
      "data-testid": a,
      ...n,
      ...f,
      className: i(s.rating, "fuse-rating", n.className)
    },
    /* @__PURE__ */ e.createElement(
      "div",
      {
        className: i(s.rating__stars, "fuse-rating__stars"),
        "data-testid": `${a}__stars-number`,
        "data-rating": t,
        style: {
          "--rating": t
        }
      }
    ),
    /* @__PURE__ */ e.createElement("div", { className: s.rating__textContainer }, l ? /* @__PURE__ */ e.createElement(_, { rating: t, size: r }) : /* @__PURE__ */ e.createElement(u, null, c), m && /* @__PURE__ */ e.createElement(p, { link: o, size: r, dataTestId: a }, m))
  );
};
d.displayName = "Rating";
export {
  d as Rating
};
